// extracted by mini-css-extract-plugin
module.exports = {"status":"style_status__1yOH7","inline":"style_inline__eDYi9","small":"style_small__xzJCo"};